import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const NewWindow16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_397)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 0.750061C1.30964 0.750061 0.75 1.30971 0.75 2.00006V9.50006H2.25V5.25H13.75V13.7501H6.5V15.2501H14C14.6904 15.2501 15.25 14.6904 15.25 14.0001V2.00006C15.25 1.3097 14.6904 0.750061 14 0.750061H2ZM3.75 3.75H2.25V2.25006H3.75V3.75ZM5.25 3.75H13.75V2.25006H5.25V3.75Z'
        fill='currentColor'
      />
      <path
        d='M4.00002 8.24998L6.68935 8.24998L0.969727 13.9696L2.03039 15.0303L7.75002 9.31063L7.75001 12L9.25001 12L9.25003 6.74999L4.00002 6.74998L4.00002 8.24998Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_397'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

NewWindow16.displayName = 'NewWindow16';
export default NewWindow16;
